import { Component, Input, Output, OnInit, EventEmitter } from "@angular/core";

@Component({
  selector: "db-update",
  templateUrl: "./db-update.component.html",
})
export class DbUpdateComponent implements OnInit {

  @Input() public bot: any;
  @Input() public muleServices: any;
  @Input() public direction: string = "right";
  @Output() public saveUpdatedBot = new EventEmitter();

  public showSelector: boolean = false;
  public loading: boolean = false;

  public editService: boolean = false;

  public ngOnInit() {
    console.log("--- db-update", this.bot);
  }

  public edit() {
    this.editService = true;
  }

  public updateBot() {
    console.log(this.bot);
    this.bot.botServiceId = this.bot.latestBotService.id;
    this.saveUpdatedBot.emit(this.bot);
  }

  public changeService($event) {
    console.log("--- change event", $event);
    this.bot.botServiceId = $event;
    this.showSelector = false;
    this.saveUpdatedBot.emit(this.bot);
  }

  public formatedGDB(item) {
    let formatedName = item;
    const parts = item.split("-");
    formatedName = `<span class="badge badge-light">${parts[0]}</span> `;
    formatedName += ` ${this.formatName(item)} `;
    formatedName += ` ${this.formatVersion(item)}`;
    formatedName += `${this.formatSuffix(item)}`;
    return formatedName;
  }

  public formatName(name) {
    const newName = name.slice(0, name.lastIndexOf("(")).replace("GDB", "");
    return ` ${newName.replace("-", " ")}`;
  }

  public formatSuffix(name) {
    const suffix = name ? name.split(")")[name.split(")").length - 1] : "";
    return ` ${suffix.replaceAll("-", " ")}`;
  }

  public formatVersion(version) {
    const endName = version.slice(version.lastIndexOf("("));
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(endName);
    return matches ? `<span class="badge badge-version">${matches[1]}</span>` : "";
  }

}
